import Inspector from './inspector';
const { RichText, InnerBlocks } = wp.blockEditor;

const Edit = ({ attributes, setAttributes }) => {
  const {
    title,
    image,
    button,
    hideButton,
    margin,
    containerized,
    imagePosition,
    space,
    addTitle,
    addImage,
    addButton,
  } = attributes;

  return (
    <>
      <Inspector attributes={attributes} setAttributes={setAttributes} />

      <section
        className={`GridCards ${margin}  ${space} ${
          addImage ? '' : 'withoutImage'
        }`}
      >
        <div className={`${containerized ? 'Container' : ''}`}>
          {addTitle && (
            <RichText
              tagName="h2"
              className={`Typography title-4 center color-blue-dark margin-large`}
              value={title}
              placeholder="Titulo (h2)"
              keepPlaceholderOnFocus
              onChange={(title) => setAttributes({ title })}
            />
          )}

          <div className={`GridCards-wrap ${imagePosition}`}>
            <div className="GridCards-sep">
              <div className="GridCards-sep-wrap editor">
                <InnerBlocks
                  template={[['app/card-sumicity']]}
                  allowedBlocks={['app/card-sumicity', 'app/topics']}
                />
              </div>

              {addButton && (
                <div className="GridCards-button-wrap">
                  <RichText
                    tagName="a"
                    className={`Button ButtonPlans buttonEdit ${
                      hideButton ? 'hidden' : ''
                    }`}
                    value={button}
                    placeholder="Botão"
                    keepPlaceholderOnFocus
                    onChange={(button) => setAttributes({ button })}
                  />
                </div>
              )}
            </div>

            {addImage && (
              <div className={`GridCards-sep GridCards-image-wrap`}>
                <figure className={`GridCards-image`}>
                  <img
                    class="MainFeatured-news-image"
                    src={image.src}
                    alt={image.alt}
                  />
                </figure>
              </div>
            )}
          </div>
        </div>
      </section>
    </>
  );
};

export default Edit;
